// Firebase initialization for the Career Constellation assessment.
// Uses the SHARED APC Firebase project (apc-intake-staging / apc-intake-prod)
// so assessment results land in the same Firestore the CRM and client portal read.
//
// Config comes from REACT_APP_FIREBASE_* env vars (see .env.local.example).
// These values are the apc-intake-staging web app config and are safe to ship
// in the client bundle (the API key is public; access is gated by Firestore rules).
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Public takers sign in with Google. Staff/coaches use the same provider but are
// recognized by their @aportlandcareer.com email + existing coaches/{uid} doc.
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

// Local emulator wiring (opt-in) for offline development.
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
  } catch (err) {
    console.warn('Failed to connect Firebase emulators:', err);
  }
}
